import { render, staticRenderFns } from "./HMStudentAvatar.vue?vue&type=template&id=66978aa6&scoped=true&"
import script from "./HMStudentAvatar.vue?vue&type=script&lang=ts&"
export * from "./HMStudentAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./HMStudentAvatar.vue?vue&type=style&index=0&id=66978aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66978aa6",
  null
  
)

export default component.exports